import React from 'react';
import Team from '../components/Team';

const BarberiaTeam = () => {
  return (
    <div className="barberia-team">
      <Team />
    </div>
  );
};

export default BarberiaTeam;
